import type React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { changeFormData, setAvatar } from "../../redux/slices";
import routes from "../../routs";
import styles from "./AvatarCard.module.scss";
import AndreyAvatar from "../../assets/pictures/avatars/Andrey1.png";
import IrinaAvatar from "../../assets/pictures/avatars/Irina2.png";
import IgorAvatar from "../../assets/pictures/avatars/Oleg1.png";
import NastyaAvatar from "../../assets/pictures/avatars/Vera1.png";
import { IRootState } from "../../redux/store";
import { AvatarName, AvatarPrompts, filterVoicesByGender, Gender, Names, VoiceTypes } from "../../utils";
import { getAvatarDefaultPrompt } from "../../utils/shared";
import { avatarPrompts } from "../Form/NewInputs/AvatarFromBlock/Bible/constants";

interface Props {
	name: string;
	avatarImage: string;
	description: string;
	gender: string;
	id: string;
}

const avatarImg: Record<AvatarName, string> = {
	irina: IrinaAvatar,
	andrey: AndreyAvatar,
	nastya: NastyaAvatar,
	igor: IgorAvatar
};

const AvatarCard: React.FC<Props> = ({
	name,
	description,
	id,
	gender,
}) => {
	const availableVoices: VoiceTypes[] | [] = useSelector((state: IRootState) => state.voicesList);
	const genderVoices: VoiceTypes[] = filterVoicesByGender(availableVoices, gender);
	const defaultText: string = getAvatarDefaultPrompt(gender as Gender, name as Names, avatarPrompts as AvatarPrompts);
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const changeAvatar = (name: string, gender: string, id: string) => {
		dispatch(changeFormData({voice: genderVoices[0].voice_id, type: id, prompt: defaultText}));
		dispatch(setAvatar({ name: name, gender: gender, brainId: "" }));
		navigate(routes.avatar);
	};

	return (
		<div className={styles.container} onClick={() => changeAvatar(name, gender, id)}>
			<img
				src={avatarImg[description as AvatarName]}
				alt={`avatar ${name}`}
				className={styles.avatarImg}
			/>
			<div className={styles.cardInfo}>
				<div className={styles.cardInfoText}>
					<h5 className={styles.avatarName}>{name}</h5>
				</div>
				<button className={styles.useAvatarLink} type="button">
					Выбрать
				</button>
			</div>
		</div>
	);
};

export default AvatarCard;
